/**
 * Majlis Mart - fly-to-cart animation.
 * When a product is successfully added to the cart (product page Add to Cart, sticky mobile bar, or quick-add on cards),
 * a small copy of the product image flies in an arc to the cart icon in the header, the icon bumps, and then the cart drawer opens.
 * It watches the add-to-cart request itself, so nothing else in the theme has to change and a failed add never animates.
 */
(function () {
  'use strict';
  if (window.__mmFly) return;
  window.__mmFly = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var last = null;
  var lastAt = 0;
  var flying = false;
  var pendingOpen = false;
  var realOpen = null;

  var css = document.createElement('style');
  css.textContent = '@keyframes mmCartBump{0%{transform:scale(1)}30%{transform:scale(1.3)}60%{transform:scale(.92)}100%{transform:scale(1)}}' +
    '.mm-cart-bump{animation:mmCartBump .55s ease}' +
    '.mm-fly{position:fixed;z-index:2147483000;margin:0;padding:0;border-radius:14px;object-fit:cover;pointer-events:none;border:2px solid #fff;box-shadow:0 12px 30px rgba(13,79,61,.35);will-change:transform,opacity}';
  document.head.appendChild(css);

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }

  function cartTarget() {
    var list = document.querySelectorAll('[data-cart-drawer-trigger]');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return list[i];
    }
    return null;
  }

  function sourceImage(btn) {
    if (btn.closest('[data-section-type="main-product"]')) {
      return document.querySelector('.mm-product-media:not(.is-hidden) img');
    }
    var card = btn.closest('article, li, [class*="card"]');
    return card ? card.querySelector('img') : null;
  }

  function bump(target) {
    if (!target) return;
    target.classList.remove('mm-cart-bump');
    void target.offsetWidth;
    target.classList.add('mm-cart-bump');
    setTimeout(function () { target.classList.remove('mm-cart-bump'); }, 650);
  }

  function land(target) {
    bump(target);
    flying = false;
    if (pendingOpen) {
      pendingOpen = false;
      if (realOpen && window.CartDrawer) realOpen.call(window.CartDrawer);
    }
  }

  function fly(info) {
    var target = cartTarget();
    if (!target) return;
    var img = info.img;
    var imgSrc = img && (img.currentSrc || img.src);
    var originEl = img && inView(img) ? img : info.btn;
    var s = originEl.getBoundingClientRect();
    var t = target.getBoundingClientRect();

    if (reduce || !imgSrc || !s.width || !document.body.animate) { bump(target); return; }

    var size = Math.round(Math.min(110, Math.max(60, Math.min(s.width, s.height) * 0.45)));
    var sx = s.left + s.width / 2 - size / 2;
    var sy = s.top + s.height / 2 - size / 2;
    var tx = t.left + t.width / 2 - size / 2;
    var ty = Math.max(0, t.top + t.height / 2 - size / 2);
    var dx = tx - sx;
    var dy = ty - sy;
    var lift = Math.min(160, Math.abs(dy) * 0.3 + 70);

    var node = document.createElement('img');
    node.className = 'mm-fly';
    node.alt = '';
    node.setAttribute('aria-hidden', 'true');
    node.src = imgSrc;
    node.style.left = sx + 'px';
    node.style.top = sy + 'px';
    node.style.width = size + 'px';
    node.style.height = size + 'px';
    document.body.appendChild(node);

    flying = true;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (node.parentNode) node.parentNode.removeChild(node);
      land(target);
    }

    var anim = node.animate([
      { transform: 'translate(0px,0px) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - lift) + 'px) scale(.7)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.14)', opacity: 0.4, offset: 1 }
    ], { duration: 800, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'forwards' });
    anim.onfinish = finish;
    anim.oncancel = finish;
    setTimeout(finish, 1400);
  }

  /* Remember what the shopper clicked, so we know which image to fly. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart-btn], [data-sticky-add-btn], [data-quick-add]');
    if (!btn || btn.disabled) return;
    last = { btn: btn, img: sourceImage(btn) };
    lastAt = Date.now();
  }, true);

  /* Fly only once Shopify has accepted the item. */
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') > -1 && last && Date.now() - lastAt < 8000) {
        var info = last;
        last = null;
        p.then(function (res) { if (res && res.ok) fly(info); }).catch(function () {});
      }
      return p;
    };
  }

  /* Hold the cart drawer back until the product has landed in the cart icon. */
  function wrapDrawer() {
    if (realOpen || !window.CartDrawer || typeof window.CartDrawer.open !== 'function') return;
    realOpen = window.CartDrawer.open;
    window.CartDrawer.open = function () {
      if (flying) { pendingOpen = true; return; }
      return realOpen.apply(this, arguments);
    };
  }
  wrapDrawer();
  document.addEventListener('DOMContentLoaded', wrapDrawer);
})();
